import mapToObject from './mapToObject.js';
import get from 'lodash/get';

function getMapValue(map) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (typeof name !== "string" || name === "" || !name) {
    return null;
  }

  if (!map) {
    return defaultValue;
  }

  name = name.split(/[\[\]\.]/).filter(function (part) {
    return part !== "";
  }).join('.');
  var data = mapToObject(map);
  var value = get(data, name, null);

  if (value === null || typeof value === 'undefined') {
    value = defaultValue;
  }

  return value;
}

export default getMapValue;
//# sourceMappingURL=getMapValue.js.map
